export default __webpack_public_path__ + "static/media/electron.22d1dbc1.svg";